/* Where things live in the dining room, in logical scene pixels. */

export const SCENE_W = 256;
export const SCENE_H = 128;

export const WINDOW_TOP = 7;
export const WINDOW_BOTTOM = 45;
export const WINDOWS = [
  { x: 32, w: 58 },
  { x: 99, w: 58 },
  { x: 166, w: 58 },
] as const;

export const DOOR = { x: 5, y: 12, w: 20, h: 50 } as const;
export const JUKEBOX = { x: 232, y: 28, w: 20, h: 36 } as const;

export const FLOOR_Y = 60;
export const BOOTH_X = [61, 128, 195] as const;
export const BOOTH_BACK_Y = 40;
export const BOOTH_TABLE_Y = 55;
export const BOOTH_HEAD_Y = 38;

export const STOOL_X = [28, 68, 108, 148, 188, 228] as const;
export const STOOL_SPRITE_Y = 72;
export const COUNTER_Y = 101;

/** Lanes customers walk along (feet y). */
export const BOOTH_LANE_Y = 66;
export const STOOL_LANE_Y = 88;
export const DOOR_X = 15;

export const FIGHT_X = 128;
export const FIGHT_Y = 74;

export const STOOL_COUNT = STOOL_X.length;

export function seatPosition(seatId: number): { x: number; y: number; kind: 'stool' | 'booth' } {
  if (seatId < STOOL_COUNT) return { x: STOOL_X[seatId] ?? 128, y: STOOL_SPRITE_Y, kind: 'stool' };
  const b = BOOTH_X[seatId - STOOL_COUNT] ?? 128;
  return { x: b, y: BOOTH_HEAD_Y, kind: 'booth' };
}

/** Anchor for a speech bubble above someone's head. */
export function headAnchor(seatId: number): { x: number; y: number } {
  if (seatId < 0) return { x: 128, y: 58 };
  const p = seatPosition(seatId);
  return p.kind === 'stool' ? { x: p.x, y: p.y + 2 } : { x: p.x, y: p.y - 1 };
}
